export default __webpack_public_path__ + "fe20cbe537297848274987ee6b049444.svg";